<template>
  <v-app class="bg-login" id="auth">
    <loading :loading="isLoading" />
    <v-main>
      <v-container class="login-container fill-height px-lg-10" fluid>
        <v-row
          align-content="center"
          class="login-container__row d-flex align-center justify-center"
        >
          <v-col
            class="hidden-md-and-down"
            :class="handlePublication() ? 'left__publication' : 'left__av'"
            cols="12"
            lg="5"
            :style="backgroundUrl"
          >
            <div v-if="handlePublication()" class="publication__text">
              <div v-html="publication.content" />
            </div>
          </v-col>
          <!-- FORM LOGIN -->
          <v-col
            v-if="!isLoading"
            class="login-container__col right"
            cols="12"
            lg="7"
          >
            <v-row>
              <v-col cols="12" md="8" offset-md="2">
                <div>
                  <router-link class="logo-container d-flex flex-column justify-center align-center" :to="{ name: 'Login' }">
                    <img
                      :src="logo"
                      :alt="altLogo"
                      :class="{ 'logo-container__image mb-2': !broker.id }"
                      class="logo"
                    />
                  </router-link>
                </div>
              </v-col>
              <v-col cols="12" md="10" offset-md="1">
                <v-card elevation="0" v-if="passWordReset === false">
                  <v-card-text>
                    <ValidationObserver
                      ref="observer"
                      v-slot="{ handleSubmit }"
                    >
                      <form @submit.prevent="handleSubmit(onSubmit)">
                        <v-row>
                          <v-col cols="12">
                            <!-- EMAIL FIELD -->
                            <ValidationProvider
                              :name="$t('login_email')"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                :label="`${$t('login_email')} *`"
                                v-model="user.email"
                                :hint="`${$t('login_email')} *`"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>
                          <!-- CURRENT PASSWORD -->
                          <v-col cols="12">
                            <ValidationProvider
                              :name="$t('login_new_password')"
                              rules="required|min:8|confirmed:password"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                name="password"
                                :label="`${$t('login_new_password')} *`"
                                v-model="user.password"
                                :hint="`${$t('login_new_password')} *`"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>

                          <!-- NEW PASSWORD -->
                          <v-col cols="12">
                            <ValidationProvider
                              :name="$t('login_new_password_confirm')"
                              rules="required|min:8"
                              vid="password"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                :label="`${$t('login_new_password_confirm')} *`"
                                v-model="user.password_confirmation"
                                :hint="`${$t('login_new_password_confirm')} *`"
                                :type="show2 ? 'text' : 'password'"
                                @click:append="show2 = !show2"
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                        <v-row justify="center">
                          <v-col
                            cols="12"
                            class="d-flex justify-space-between flex-row align-baseline"
                          >
                            <v-spacer />
                            <language-menu class="mx-auto" color="#B5BEC4" />
                          </v-col>
                          <v-btn
                            color="secondary"
                            type="submit"
                            elevation="0"
                            :loading="loading"
                          >
                            {{ $t('btn_establish') }}
                          </v-btn>
                        </v-row>
                        <br />
                      </form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
                <v-card rounded elevation="0" class="pa-6" v-else>
                  <v-card-text>
                    <v-row class="mb-5" dense>
                      <v-col cols="12" class="d-flex justify-center">
                        <img
                          height="64"
                          width="64"
                          src="@/assets/008_check.png"
                          alt="Password reset successfully"
                        />
                      </v-col>
                      <v-col cols="12" class="d-flex justify-center align-center">
                        <span class="text-h6 primary--text">
                          {{ $t('login_config_password_successful') }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-btn
                        color="secondary"
                        type="submit"
                        elevation="0"
                        :to="{ name: 'Login', query: { broker: $route.query.broker } }"
                      >
                        {{ $t('login_login') }}
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UserService from '@/services/user'
import LanguageMenu from '@/components/commons/LanguageMenu'
import BrokerService from '@/services/broker'
import PublicSettingService from '@/services/publicSetting'
import LanguageService from '@/services/language'
import Loading from '@/components/commons/Loading'
import { setVeeLocale } from '@/utils'
// import VueRecaptcha from 'vue-recaptcha'
export default {
  components: { /* VueRecaptcha */ LanguageMenu, Loading },
  data() {
    return {
      show1: false,
      show2: false,
      isLoading: false,
      passWordReset: false,
      user: {
        token: this.$route.query.token,
        email: '',
        password: '',
        password_confirmation: ''
      },
      broker: {},
      publication: {
        date: null,
        content: null
      },
      publicSettings: [],
      whiteBranding: null
    }
  },
  async created() {
    this.isLoading = true
    try {
      await this.populateLanguages()
      await this.getPublicSettings()

      const broker = this.$route.query.broker
      if (broker && this.whiteBranding) {
        await this.getBrokerInfo(broker)
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('language', ['idiom']),
    currentDate() {
      return this.$date().format('YYYY-MM-DD')
    },
    logo() {
      return this.broker.id ? `data:image/png;base64,${this.broker.img_desktop}` : require('@/assets/logo_av_securities.png')
    },
    altLogo() {
      return this.broker.id ? `${this.broker.name} Logo` : 'AV Agil Logo'
    },
    background() {
      return this.broker.id && this.broker.img_background ? this.broker.img_background : require('@/assets/login_background.webp')
    },
    backgroundUrl() {
      const image = this.broker.id && this.broker.img_background ? this.broker.img_background : require('@/assets/login_background.webp')
      return `background-image: url(${image})`
    }
  },
  watch: {
    idiom(newVal) {
      const content = this.publicSettings.find(
        item => item.key == `publications_content_${newVal.code}`
      )?.value
      this.$set(this.publication, 'content', content ?? null)
    }
  },
  methods: {
    ...mapActions('language', ['setLanguages', 'setLanguage', 'setIdiom']),
    async onSubmit() {
      try {
        await UserService.updatePassword(this.user, false)
        this.passWordReset = true
      } catch (e) {
        this.$dialog.notify.error(e)
      }
    },

    async getBrokerInfo(code) {
      this.isLoading = true
      try {
        const { data } = await BrokerService.getBrokerInfo(code)
        this.broker = data
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    async populateLanguages() {
      const params = {
        limit: 999,
        'filter[active]': 1,
        'fields[languages]': 'id,code,name',
        include: 'translations'
      }
      const { data } = await LanguageService.fetch(params)
      const languages = data.data.map(item => {
        let messages = {}
        item.translations.forEach(item => {
          messages[item.label] = item.translation
        })
        return { ...item, translations: messages }
      })

      this.setLanguages(languages)

      // Broswer Language
      let lang = navigator.language.substr(0, 2)
      let defaultLang = languages.find(item => item.code === lang)
      if (!defaultLang) {
        defaultLang = languages.find(item => item.code === 'es')
        lang = 'es'
      }

      // Set Browser languages
      this.setIdiom(defaultLang)
      setVeeLocale(lang)
    },

    async getPublicSettings() {
      const { data } = await PublicSettingService.fetch({})
      this.publication.date = data.find(
        item => item.key == 'publications_date'
      )?.value
      this.publication.content = data.find(
        item => item.key == `publications_content_${this.idiom.code}`
      )?.value
      this.whiteBranding = data.find(
        item => item.key == 'white_branding'
      )?.value

      this.publicSettings = data
    },

    handlePublication() {
      return (
        this.handlePublicationDate() &&
        this.handlePublicationContent() &&
        !this.broker.id &&
        !this.loading
      )
    },

    handlePublicationDate() {
      return (
        this.publication.date !== '' &&
        this.publication.date !== null &&
        this.publication.date >= this.currentDate
      )
    },

    handlePublicationContent() {
      return (
        this.publication.content !== null && this.publication.content !== ''
      )
    }
  }
}
</script>
<style>
#auth label.v-label {
  transform: translateY(-18px) scale(0.75);
}
</style>
<style scoped>
.theme--light.v-application.bg-login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
  background: rgb(255, 255, 255);
  background-size: cover !important;
  background-repeat: no-repeat;
  font-family: 'Libre Franklin', serif;
}
.login-container {
  min-height: 100vh;
}
.login-container__row {
  min-height: 100vh;
}
.login-container__col {
  min-height: 100vh;
}
.left__av {
  background-size: cover;
  border-radius: 2rem;
  height: 820px;
  background-position: center;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}

.left__publication {
  background-image: url('../../assets/AV_004_inicio_portal_clientes_sinletra.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  height: 100vh;
  padding: 50px;
}
.left__text {
  position: absolute;
  width: 50px;
  margin-left: -200px;
  text-align: left;
  font-family: 'Libre Franklin', serif;
  font-weight: normal;
  letter-spacing: -1.1px !important;
  color: #0294de !important;
  opacity: 1;
}

.publication__text {
  color: white;
  width: 100vh;
}

.right {
  display: flex;
  align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
}

.links a {
  letter-spacing: 0px;
  color: #00559e;
  opacity: 1;
  text-decoration: none;
}

.logo-container__text {
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
  font-family: 'Libre Franklin', serif;
  letter-spacing: 0;
  color: #B5BEC4;
  opacity: 1;
}

.form label {
  letter-spacing: 0;
}

.forgot-password-link,
.forgot-password-link:visited {
  color: var(--v-primary-base) !important;
}

span {
  color: #B5BEC4 !important;
}

icon.theme--light.v-icon {
  color: #B5BEC4 !important;
}

.logo {
  max-width: 300px;
}

@media screen and (min-width: 1024px) {
  .logo {
    max-width: 70%;
  }
}
</style>
